import { useMemo, useState } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { Button } from "@covertree/ui";

import {
  mapAchPaymentMethodName,
  mapCreditCardPaymentMethodExpiration,
  mapCreditCardPaymentMethodName,
} from "../utils";
import { PaymentMethodsModal } from "./PaymentMethodsModal";
import { usePolicyDetails } from "../../../../PolicyDetailsContext";

export function PaymentMethods() {
  const { policy } = usePolicyDetails();
  const [isModalOpen, setModalOpen] = useState(false);

  const defaultCard = useMemo(
    () =>
      policy?.paymentMethods?.creditCardPaymentMethods?.find(
        (card) => card.default
      ),
    [policy?.paymentMethods?.creditCardPaymentMethods]
  );

  const defaultAch = useMemo(
    () => policy?.paymentMethods?.achPaymentMethods?.find((ach) => ach.default),
    [policy?.paymentMethods?.achPaymentMethods]
  );

  return (
    <Box mb={3}>
      <Typography variant="h4">Payment method</Typography>
      <Stack
        mt={3}
        p={3}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        bgcolor="secondary.contrastText"
        borderRadius={2}>
        <Stack>
          <Typography>
            {!defaultAch && !defaultCard && "No default payment method found"}
            {defaultCard && mapCreditCardPaymentMethodName(defaultCard)}
            {defaultAch && mapAchPaymentMethodName(defaultAch)}
          </Typography>
          {defaultCard && (
            <Typography variant="body2" color="text.disabled">
              {mapCreditCardPaymentMethodExpiration(defaultCard)}
            </Typography>
          )}
        </Stack>
        <Button
          variant="outlined"
          size="small"
          onClick={() => setModalOpen(true)}>
          Edit
        </Button>
      </Stack>
      <PaymentMethodsModal
        open={isModalOpen}
        onClose={() => setModalOpen(false)}
      />
    </Box>
  );
}
